import React, {useState, useRef } from "react";
import Price from "./productsPrice";
import Modal from 'react-bootstrap/Modal'
import ShowimagesLoading from "./showImagesLoading";
import { MdRemoveCircleOutline, MdAddShoppingCart, MdEdit, MdDeleteForever, MdUnpublished, MdRestore } from 'react-icons/md';
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { addItem, isAuthenticated } from '../auth';
import PriProductTable from "../pageInside/PriProductTable";
import ViewProdTable from "../pageInside/vIewProdTable"
import { AddToDealToDay, softDeleteProduct, restoreProduct, permanentDeleteProduct } from '../auth/apiProduct';
import {extract_Na_Ing_galeries, extract_Urls_galeriesID, compareArrays, extract_K_V_filterProduct, checkFilterImages, selectUrl_By_GaleriesCheck, validateProductData, getProductPrimaryImage} from '../auth/elakay-utils';
import { buildProductEditPath } from '../../utils/publicIdentifier';
import {GrView} from "react-icons/gr";
import "../pages/UserProducts.css";
import { getElakayLanguageContext } from "./dataElakay";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["cardTable"]?.[key] || fallback;

const CardTable = ({
    myShop, 
    infoSource, 
    setProductaddToDeal,
    setShowSideDeal,
    loadProductsByArrival,
    DealProduct,
    showSideDeal,
     myFilters ={filters: {"categoriesID.gategoriesLink": []}},
    getFilterUserProd = {asc: 'asc', unpublished: false, limit : 12, sortBy: 'createdAt', search: ''},
    trashMode = false,
    })=>{
 const [showListe, setShowListe] = useState(false);
 const [values, setValues] = useState(false);
 const { token } = isAuthenticated();
 const {
  getButtonTitle,
  trashItems,
 } = infoSource
 __setElakayInfoSource(infoSource);
  const handleDelete = async (product) => {
    if (!window.confirm(__elakayText("t210", "Move this product to the trash? You'll have 14 days to restore it before it's permanently deleted."))) return;
    const res = await softDeleteProduct(token, product._id);
    if (!res?.error) {
      loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
      trashItems?.(token);
    } else alert(res.error);
  };

  const handleRestore = async (product) => {
    const res = await restoreProduct(token, product._id);
    if (!res?.error) {
      loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
      trashItems?.(token);
    } else alert(res.error);
  };

  const handlePermanentDelete = async (product) => {
    if (!window.confirm(__elakayText("t211", "Permanently delete this product? This cannot be undone."))) return;
    const res = await permanentDeleteProduct(token, product._id);
    if (!res?.error) {
      loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
      trashItems?.(token);
    } else alert(res.error);
  };
      function calculateQuantities(product) {
            const quantities = product.filterProduct.reduce((total, item) => total + (item.quantity || 0), 0);
        
            return quantities
        }

        function calculateSales(product) {
            const sales = product.filterProduct.reduce((total, item) => total + (item.sold || 0), 0);
        
            return sales
        }

       const handleDealToggle = (product) => {
         if (!product.dealTodays) {
           setShowSideDeal(!showSideDeal);
           setProductaddToDeal(product);
         } else {
           AddToDealToDay(token, product._id, { dealTodays: false, discount: 0 }).then(() => {
             loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
           });
         }
       };
    const ProductViewModal = () => (
        <div className="container">
            <div className="row justify-content-center " >
                <Modal
                    size="xl"
                    show={showListe}
                    onHide={() => setShowListe(false)}
                    dialogClassName="modal-90w"
                    aria-labelledby="example-custom-modal-styling-title"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                        {infoSource.laguangeElakay('title', infoSource.languageAPI).itemsView}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
            {
        
            <div 
            style={{overflow: "auto" }}
            >
                <ViewProdTable
                data = {values}
                infoSource={infoSource}
                />
                </div>
            }
                    </Modal.Body>
                </Modal>
            </div>
        </div>

    )
            const renderTrashActionButtons = (product) => (
              <div className="userproducts-cardtable-actions">
                {product.canBeRestored !== false ? (
                  <button className="userproducts-cardtable-btn userproducts-cardtable-btn-restore" data-toggle="tooltip" data-placement="top" title={__elakayText("t212", "Restore")} onClick={() => handleRestore(product)}>
                    <MdRestore />
                  </button>
                ) : (
                  <span className="userproducts-cardtable-btn userproducts-cardtable-btn-restore userproducts-cardtable-btn-disabled" title={__elakayText("t213", "This product's CJ Dropshipping source no longer exists and must be re-verified before it can be restored.")}>
                    <MdRestore />
                  </span>
                )}
                <button className="userproducts-cardtable-btn userproducts-cardtable-btn-delete" data-toggle="tooltip" data-placement="top" title={__elakayText("t214", "Delete permanently")} onClick={() => handlePermanentDelete(product)}>
                  <MdDeleteForever />
                </button>
              </div>
            );

            const renderActionButtons = (product) => (
              trashMode ? renderTrashActionButtons(product) :
              <div className="userproducts-cardtable-actions">
                      <button className="userproducts-cardtable-btn userproducts-cardtable-btn-delete"  data-toggle="tooltip" data-placement="top" title={getButtonTitle("deleteProduct")} onClick={()=>handleDelete(product)}>
                        <MdDeleteForever />
                      </button>
                       <button className="userproducts-cardtable-btn userproducts-cardtable-btn-view"  data-toggle="tooltip" data-placement="top" title={getButtonTitle("viewProduct")} onClick={()=>{setShowListe(true); setValues(product) }}>
                        <GrView />
                      </button>
                      <button className="userproducts-cardtable-btn userproducts-cardtable-btn-deal" onClick={()=>handleDealToggle(product)} data-toggle="tooltip" data-placement="top" title={getButtonTitle(product.dealTodays ?"deleteToDeal":"addToDeal")}>
                        {product.dealTodays ? <MdRemoveCircleOutline /> : <FaPlus />}
                      </button>
                      <Link to={buildProductEditPath(product)} className="userproducts-cardtable-btn userproducts-cardtable-btn-edit"  data-toggle="tooltip" data-placement="top" title={getButtonTitle("editProduct")}>
                        <MdEdit />
                      </Link>
                     {!validateProductData(product) && <Link to={`/myshop?sel=true&ip=${product._id}`} className="userproducts-cardtable-btn userproducts-cardtable-btn-unpublished"  data-toggle="tooltip" data-placement="top" title={getButtonTitle("continueSelling")}>
                        <MdUnpublished />
                      </Link>}
              </div>
            );

            const renderTrashInfo = (product) => (
              <div className="userproducts-cardtable-trash-info">
                <div>
                  {product.providerDeleted
                    ? __elakayText("t215", "Removed by CJ Dropshipping")
                    : __elakayText("t216", "Deleted by seller")}
                </div>
                {product.deletionExpiresAt && (
                  <div>
                    {Math.max(0, Math.ceil((new Date(product.deletionExpiresAt).getTime() - Date.now()) / 86400000))} {__elakayText("t217", "day(s) left")}
                  </div>
                )}
              </div>
            );
    
    // Fonction pour déterminer la couleur du border
    const couleurBorder = (product) => {
        const urls = extract_Urls_galeriesID(product?.galeriesID);
        const galeries = extract_Na_Ing_galeries(product?.galeries);  
        const K_V_filterProduct = extract_K_V_filterProduct(product?.filterProduct);
        const checkFilImages = checkFilterImages(product?.filters);

        const productIncomplete = !validateProductData(product);

        const filColorIncompatible = compareArrays(K_V_filterProduct.values, galeries.names)
        const img_N_E_galeries = compareArrays(urls, galeries.images)
        const img_N_E_filterProduct = compareArrays(urls, checkFilImages.urls)

        let Border_Ep_So = '3px solid';

        if (productIncomplete) {
            return `${Border_Ep_So} rgba(220,53,69,.45)`
        } else if (filColorIncompatible.error ||
            img_N_E_filterProduct.error || 
            img_N_E_galeries.error ||
            checkFilImages.error) {
            return `${Border_Ep_So} rgba(255,193,7,.45)`
        } else {
            return `${Border_Ep_So} rgba(25,135,84,.45)`
        } 
    }

    // Fonction pour déterminer la couleur du shadow
    const couleur = (product) => {
        const urls = extract_Urls_galeriesID(product?.galeriesID);
        const galeries = extract_Na_Ing_galeries(product?.galeries);  
        const K_V_filterProduct = extract_K_V_filterProduct(product?.filterProduct);
        const checkFilImages = checkFilterImages(product?.filters);

        const productIncomplete = !validateProductData(product);

        const filColorIncompatible = compareArrays(K_V_filterProduct.values, galeries.names)
        const img_N_E_galeries = compareArrays(urls, galeries.images)
        const img_N_E_filterProduct = compareArrays(urls, checkFilImages.urls)

        let shadowPosition = '1px 3px 4px';

        if (productIncomplete) {
            return `${shadowPosition} rgba(220,53,69,.45)`
        } else if (filColorIncompatible.error ||
            img_N_E_filterProduct.error || 
            img_N_E_galeries.error ||
            checkFilImages.error) {
            return `${shadowPosition} rgba(255,193,7,.45)`
        } else {
            return `${shadowPosition} rgba(25,135,84,.45)`
        } 
    }

    const getRowStatusClass = (product) => {
        const urls = extract_Urls_galeriesID(product?.galeriesID);
        const galeries = extract_Na_Ing_galeries(product?.galeries);  
        const K_V_filterProduct = extract_K_V_filterProduct(product?.filterProduct);
        const checkFilImages = checkFilterImages(product?.filters);

        const productIncomplete = !validateProductData(product);

        const filColorIncompatible = compareArrays(K_V_filterProduct.values, galeries.names)
        const img_N_E_galeries = compareArrays(urls, galeries.images)
        const img_N_E_filterProduct = compareArrays(urls, checkFilImages.urls)

        if (productIncomplete) {
            return 'userproducts-cardtable-row-incomplete'
        } else if (filColorIncompatible.error ||
            img_N_E_filterProduct.error || 
            img_N_E_galeries.error ||
            checkFilImages.error) {
            return 'userproducts-cardtable-row-warning'
        } else {
            return 'userproducts-cardtable-row-complete'
        } 
    }

const divTable = ()=>{
   return <div className="userproducts-cardtable-premium-container">
                <table className="userproducts-cardtable-premium table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" className="userproducts-cardtable-image-cell">{__elakayText("t001", "images")}</th>
                            <th scope="col">
                            {infoSource.laguangeElakay('label', infoSource.languageAPI).name}
                                </th>
                            <th scope="col" >{__elakayText("t002", "description")}</th>
                            <th scope="col" style={{ minWidth: "95px" }}>
                            {infoSource.laguangeElakay('label', infoSource.languageAPI).prix}
                            </th>   
                            <th scope="col" style={{ minWidth: "95px" }}>
                            {infoSource.laguangeElakay('label', infoSource.languageAPI).quantity}
                                </th>
                            <th scope="col" style={{ minWidth: "95px" }}>
                            {infoSource.laguangeElakay('label', infoSource.languageAPI).sold}
                            </th>
                        </tr>
                    </thead>
                    <tbody >
                        {myShop?.map((o, i) => (
                          <tr 
                            key={i} 
                            className={getRowStatusClass(o)}
                            style={{
                                border: couleurBorder(o),
                                borderRadius: "8px", 
                                boxShadow: couleur(o), 
                                transition: "box-shadow 0.2s ease, transform 0.2s ease",
                                cursor: "pointer"
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.14)";
                                e.currentTarget.style.transform = "translateY(-3px)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = couleur(o);
                                e.currentTarget.style.transform = "translateY(0)";
                            }}
                          >
                                <td className="userproducts-cardtable-image-cell">
                                   <div className="userproducts-cardtable-image-container" style={{
                                boxShadow: couleur(o), 
                                transition: "box-shadow 0.2s ease, transform 0.2s ease",
                                cursor: "pointer"
                            }}>
                                   <ShowimagesLoading
                                        src={getProductPrimaryImage(o)}
                                        width={120}
                                        alt={__elakayText("t003", "Elakay note images")}
                                        style={{ height: "100%", width: "100%" }}
                                    />
                                    </div>
                                </td>
                                <td>
                                  <infoSource.TruncatedText text={o?.name} limits={[40, 30]} showToggle = {false}/>
                                  {/* <span dangerouslySetInnerHTML={{ __html: o?.name}}></span> */}
                                </td>
                                 <td>
                                    <div className="userproducts-cardtable-description">
                                      <infoSource.TruncatedText text={o?.description} limits={[70, 50]} showToggle = {true}/>
                                    {/* <p dangerouslySetInnerHTML={{ __html: o?.description}}></p> */}
                                    </div>
                                    {trashMode && renderTrashInfo(o)}
                                    {renderActionButtons(o)}
                                </td>
                                <td className="userproducts-cardtable-price">
                                    <Price
                                        products={o}
                                        showAddToCart={()=>(false)}
                                    />
                                </td>
                                <td className="userproducts-cardtable-number">
                                    {calculateQuantities(o)}
                                </td>
                                <td className="userproducts-cardtable-number">
                                    {calculateSales(o)}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                </table>
            </div>
}
    return<>
        {ProductViewModal()}
        {divTable()}
        </>

}

export default CardTable;
